import { render } from "./layouts-header.vue?vue&type=template&id=c2f9848a&scoped=true"
import script from "./layouts-header.vue?vue&type=script&lang=js"
export * from "./layouts-header.vue?vue&type=script&lang=js"

import "./layouts-header.vue?vue&type=style&index=0&id=c2f9848a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2f9848a"]])

export default __exports__